
export default class Alert {
    constructor (dto) {
        this.id = 0;
        this.documentId = 0;
        this.notifyByEmail = false;
        this.date = '';
        this.description = '';

        if (dto) {
            Object.assign(this, dto, {
                id: dto.alertId,
            });
        }
    }

    toDto () {
        return {
            AlertID: this.id,
            DocumentId: this.documentId,
            Date: this.date,
            NotifyByEmail: this.notifyByEmail,
            Description: this.description,
        };
    }
}
